// 场景注册表：聚合各场景目录的 SceneModule → SCENES / getScene / getSvgRender / hasSvgRender。
// 新增场景：建 scenes/<id>/ 目录（含 index.ts 导出 module），在此 import + 加入 MODULES 即可。
import type { SceneType } from '../api/types'
import type { ScenePlugin, SvgRender } from './_shared/types'
import { module as chartRace } from './chart-race'
import { module as rankingReveal } from './ranking-reveal'
import { module as vsComparison } from './vs-comparison'
import { module as quoteCard } from './quote-card'
import { module as mapTrajectory } from './map-trajectory'
import { module as newsBrief } from './news-brief'
import { module as yearWrapped } from './year-wrapped'
import { module as chatStory } from './chat-story'

const MODULES = [
  chartRace,
  rankingReveal,
  vsComparison,
  quoteCard,
  mapTrajectory,
  newsBrief,
  yearWrapped,
  chatStory,
]

// id → 注册表条目（PreviewScreen 用 Component/Composition，EditorPanel 用 EditorComponent）
export const SCENES = Object.fromEntries(
  MODULES.map((m) => [m.id, { id: m.id, Component: m.Component, Composition: m.Composition, EditorComponent: m.Editor }]),
) as Record<SceneType, ScenePlugin>

export function getScene(id: string): ScenePlugin | undefined {
  return SCENES[id as SceneType]
}

export function getSvgRender(id: string): SvgRender | undefined {
  return MODULES.find((m) => m.id === id)?.svgRender
}

export function hasSvgRender(id: string): boolean {
  return !!getSvgRender(id)
}
